import React from 'react'

export default function FormPageHeader(props) {
    return (
        <div className="header-part">
            <h1>{props.header}</h1>
        </div>
    )
}
